export default __webpack_public_path__ + "static/media/imagem-senhora.924584ff.png";